import { render, staticRenderFns } from "./AdditionalMealsForGroupCompanies.vue?vue&type=template&id=20a9a99c&scoped=true"
import script from "./AdditionalMealsForGroupCompanies.vue?vue&type=script&lang=js"
export * from "./AdditionalMealsForGroupCompanies.vue?vue&type=script&lang=js"
import style0 from "./AdditionalMealsForGroupCompanies.vue?vue&type=style&index=0&id=20a9a99c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a9a99c",
  null
  
)

export default component.exports